import { render, staticRenderFns } from "./Lawyer.vue?vue&type=template&id=7b67c7a0"
import script from "./Lawyer.vue?vue&type=script&lang=js"
export * from "./Lawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports